module.exports = __webpack_public_path__ + "static/media/filter-chip-close.38ae0021.svg";